module.exports = __webpack_public_path__ + "img/hamilton-academical-fc.6a1b6217.png";